import { useEffect, useRef, EffectCallback, DependencyList } from 'react'

// Same functionality as useEffect, just not on the first render.
// This avoid double initial render for cases like:
// const [someInitialValue, setSomeInitialValue] = useState(props.data)
// useEffectAfterMount(() => {
//     setSomeInitialValue(props.data)
// }, [props.data])
export function useEffectAfterMount(effect: EffectCallback, deps: DependencyList) {
    const isFirst = useRef(true)

    useEffect(() => {
        if (isFirst.current) {
            isFirst.current = false
            return
        }

        return effect()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)
}
